import { useTranslation } from "next-i18next";
import styled from "styled-components";
import { device, size } from "../../constants";
import { utilityLinks, workWithUsLinkProps } from "../../data/contact-info";
import { useWindowSize } from "../../hooks/useWindowResize";
import LanguageSelector from "../LanguageSelector";
import { StaticI18nLink } from "../Link";
import DropdownItem from "../menu/components/DropdownItem";
import Nav from "../menu/Nav";
import { DropdownButton } from "../menu/styles/Dropdown.styles";
import { NavLinkExternalRaw } from "../menu/styles/NavLink.styles";
import {
	LanguageWrapper,
	Nav as NavBS,
	NavLink,
	NavMobileWrapper,
} from "../menu/styles/Topbar.styles";
import { Topbar } from "../menu/Topbar";

const NavBlogWrapper = styled(NavBS)`
  gap: 32px;
  padding: 8px;
  padding-top: 24px;
  flex-direction: column!important;

  @media ${device.laptop} {
    gap: 12px;
    padding: 0;
    flex-direction: row!important;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
  }

  @media ${device.laptopL} {
    gap: 32px;
  }
	
	${DropdownButton}, ${NavLinkExternalRaw} {
		/* background-color: ${({ theme }) => theme.colors["background-03"]}; */
		color: ${({ theme }) => theme.colors["neutral-07"]};
	}

	${DropdownButton} {
		svg path {
			fill: ${({ theme }) => theme.colors["neutral-07"]} !important;
		}
	}
	
	:is([data-theme="dark"] &) {
		${DropdownButton}, ${NavLinkExternalRaw} {
			color: ${({ theme }) => theme.colors["neutral-01"]};
		}

		${DropdownButton} {
			svg path {
				fill: ${({ theme }) => theme.colors["neutral-01"]} !important;
			}
		}
	}
`;

export function TopbarBlog({ showTheme = true, isProduct = false }) {
	const { width } = useWindowSize();
	const { t } = useTranslation();

	const isLaptop = width >= size.laptop;
	const isLaptopL = width >= size.laptopL;

	return (
		<Topbar showTheme={showTheme}>
			<NavBlogWrapper>
				<Nav.Dropdown title={t("header.solutions")}>
					<DropdownItem rel="follow" href="/produtos/rpa">
						{t("header.menuItems.rpa")}
					</DropdownItem>
					<DropdownItem rel="follow" href="/produtos/squad-ia">
						{t("header.menuItems.squad-ia")}
					</DropdownItem>
					<DropdownItem rel="follow" href="/business-division/acceleration">
						{t("header.menuItems.acceleration")}
					</DropdownItem>
					<DropdownItem rel="follow" href="/business-division/disruption">
						{t("header.menuItems.disruption")}
					</DropdownItem>
					<DropdownItem rel="follow" href="/business-division/expansion">
						{t("header.menuItems.expansion")}
					</DropdownItem>
				</Nav.Dropdown>

				{isProduct && (
					<Nav.Dropdown title={"Cases"}>
						<DropdownItem rel="follow" href="/casos/br-com">
							BR COM (RPA)
						</DropdownItem>
						<DropdownItem rel="follow" href="/casos/brinks">
							BRINKS (RPA)
						</DropdownItem>
						<DropdownItem rel="follow" href="/casos/grupo-avenida">
							GRUPO AVENIDA (RPA)
						</DropdownItem>
						<DropdownItem rel="follow" href="/casos/zignet">
							ZIGNET (RPA)
						</DropdownItem>
					</Nav.Dropdown>
				)}

				<Nav.Dropdown title={t("header.content")}>
					<DropdownItem href="/blog" rel="follow">
						{t("header.menuItems.blog")}
					</DropdownItem>
				</Nav.Dropdown>

				<NavMobileWrapper>
					<Nav.Item
						title={t("header.workWithUs")}
						href={utilityLinks.workWithUs}
						{...workWithUsLinkProps}
						isExternal
					/>
				</NavMobileWrapper>

				<NavMobileWrapper>
					<Nav.Item
						title={t("header.contact")}
						href="/#contact-us"
						target="_blank"
						rel="noopener noreferrer nofollow"
					/>
				</NavMobileWrapper>

				<NavMobileWrapper>
					<LanguageWrapper>
						<LanguageSelector showLabel={false} />
					</LanguageWrapper>
				</NavMobileWrapper>
			</NavBlogWrapper>
		</Topbar>
	);
}
